import { runInAction } from 'mobx';
import { configurationSettings } from '../../../../../configuration/configuration-settings';
import { LoyaltyAuthenticationType } from '../../../../../configuration/types/loyalty/loyalty-authentication-type';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
export const vistaLoyaltyMemberIsAuthenticatedCookieName = 'vista-loyalty-member-is-authenticated';
const isAuthCookieSet = () => {
    return (typeof window !== 'undefined' && window.document.cookie.includes(vistaLoyaltyMemberIsAuthenticatedCookieName));
};
/**
 * The interval identifier set during `updateIsMemberSignedInFromCookie`.
 */
let isMemberSignedInFromCookieInterval;
/**
 * Updates the `isMemberSignedIn` state based on the presence of an active Loyalty authentication cookie.
 * @param startInterval Determines whether an interval will be started to automatically update the `isMemberSignedIn` state every 0.5 seconds.
 */
export const updateIsMemberSignedInFromCookie = (startInterval) => {
    const { authentication, onSignedOut } = configurationSettings.data.loyalty;
    if (authentication.type !== LoyaltyAuthenticationType.Cookie &&
        authentication.type !== LoyaltyAuthenticationType.WorkstationCookie) {
        return;
    }
    const isSignedIn = isAuthCookieSet();
    // Only call `onSignedOut` when this method is called by the interval (startInterval: false)
    if (!isSignedIn && !startInterval) {
        onSignedOut === null || onSignedOut === void 0 ? void 0 : onSignedOut(true);
        clearIsMemberSignedInFromCookieInterval();
    }
    runInAction(() => {
        temporaryLoyaltyDomainStore.data.isMemberSignedIn = isSignedIn;
    });
    // Don't start the interval if the member is not signed in.
    // The interval will be started on sign in, or on member create.
    if (isSignedIn && startInterval) {
        clearIsMemberSignedInFromCookieInterval();
        isMemberSignedInFromCookieInterval = window.setInterval(() => updateIsMemberSignedInFromCookie(false), 500);
    }
};
export const clearIsMemberSignedInFromCookieInterval = () => {
    if (isMemberSignedInFromCookieInterval) {
        window.clearInterval(isMemberSignedInFromCookieInterval);
    }
};
//# sourceMappingURL=update-is-member-signed-in-from-cookie.js.map